/** Joins the class names that are set: `cx(styles.a, on && styles.b)`. */
export const cx = (...names: (string | false | null | undefined)[]) =>
  names.filter(Boolean).join(' ')
